import type { FunctionalComponent as FC } from 'preact';
import { Fragment } from 'preact/compat';

import type { Message } from '../../types/messages';
import { getMessageType } from '../../utils';

import { MessageBubble } from '../MessageBubble';
import { MessageCsatRating } from '../MessageCsatRating';
import { MessageWithButtons } from '../MessageWithButtons';
import { MessagesDate } from '../MessagesDate';

interface Props {
  messages: Message[];
  isLoading?: boolean;
  isInitialLoad?: boolean;
}

export const MessagesList: FC<Props> = ({ messages }) => {
  return messages.map((message, index) => {
    const { isChatMessage, isCsatReasonRequest, isCsatRatingRequest, isChatBotRequest, hasButtons } =
      getMessageType(message);

    const prevMessage = messages[index + 1] ? messages[index + 1] : message;

    const prevMessageDate = prevMessage ? prevMessage.createDate + 'Z' : undefined;
    const currentMessageDate = message.createDate + 'Z';

    return (
      <Fragment key={message.id}>
        {isChatMessage ? <MessageBubble {...message} /> : null}
        {isCsatRatingRequest && hasButtons ? <MessageCsatRating {...message} /> : null}
        {(isCsatReasonRequest || isChatBotRequest) && hasButtons ? <MessageWithButtons {...message} /> : null}
        {prevMessageDate && currentMessageDate ? (
          <MessagesDate
            prevDate={prevMessageDate}
            currentDate={currentMessageDate}
            showDateAlways={index === messages.length - 1}
          />
        ) : null}
      </Fragment>
    );
  });
};
